import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './Components/Login';
import SignUp from './Components/SignUp';
import React, { useState, useEffect } from 'react';
import { handleLogout } from './Backend/Authentication/AuthService';

/* global __initial_auth_token */
import { Layout1 } from './Components/Utility/Layout';
import { setGuestInfo, getCurrentUserId, getCurrentUserName } from './Backend/Authentication/UserStore';
import { supabase } from './Backend/supabaseClient';
import TopicSelector from './Components/Daily/TopicScreen/TopicSelector';
import RecorderPage from './Components/Daily/TestScreen/RecorderPage';
import SelectionGrid from './Components/Daily/SelectionScreen/SelectionGrid';
import TestHistoryPage from './Components/Daily/TestHistory/TestHistoryPage';
import TestAttemptHistoryPage from './Components/Daily/ResultScreen/TestAttemptHistoryPage';
import HomeScreenBoard from './Components/Home/HomeScreen';
import PriceScreen from './Components/Pricing/PriceScreen';
import PrivacyPolicyPage from './Components/Privacy/PrivacyScreen';
import TermsOfServicePage from './Components/Privacy/TermsScreen';
import AboutScreen from './Components/About/AboutScreen';
import AuthCallback from './Components/AuthCallback';


const generateUUID = () => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return 'guest-' + Math.random().toString(36).substr(2, 9);
};

export default function App() {
  // 1. FIREBASE USER STATE
  const [user, setFirebaseUser] = useState(null);
  const [guestId] = useState(() => generateUUID());

  // 3. UI STATES
  const [authLoading, setAuthLoading] = useState(true);
  const [globalNotice, setGlobalNotice] = useState(null);
  const [globalDialog, setGlobalDialog] = useState(null);

  useEffect(() => {
    setGuestInfo(guestId, "Guest");
  }, [guestId]);

  // --- EFFECT 2: FIREBASE LISTENER ---
  // --- EFFECT: FIREBASE LISTENER ---
  useEffect(() => {
    // 1. Initial Check (Page Load)
    supabase.auth.getSession().then(({ data: { session } }) => {
      setFirebaseUser(session?.user ?? null);
      setAuthLoading(false);
    });

    // 2. Real-time Subscription (Login/Logout events)
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setFirebaseUser(session?.user ?? null);
      setAuthLoading(false);
    });

    // Cleanup: Remove listener when app unmounts
    return () => subscription.unsubscribe();
  }, []); // Empty array is correct because 'supabase' never changes


  const activeUserId = getCurrentUserId();
  const activeUserName = getCurrentUserName();

  // --- HELPERS ---
  const handleSetGlobalNotice = (notice) => setGlobalNotice(notice);
  const handleSetGlobalDialog = (dialog) => setGlobalDialog(dialog);


  // --- LOADING SCREEN ---
  // Show this while onAuthStateChanged is running
  if (authLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        <div className="text-xl font-semibold">Loading...</div>
      </div>
    );
  }


  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <Layout1
              user={user}
              firstName={activeUserName}
              handleLogout={handleLogout}
              globalNotice={globalNotice}
              setGlobalNotice={handleSetGlobalNotice}
              dialog={globalDialog}
              setGlobalDialog={handleSetGlobalDialog}
            >
              <HomeScreenBoard />
            </Layout1>
          }
        />

        <Route
          path="/topics"
          element={
            <Layout1
              user={user}
              firstName={activeUserName}
              handleLogout={handleLogout}
              globalNotice={globalNotice}
              setGlobalNotice={handleSetGlobalNotice}
              dialog={globalDialog}
              setGlobalDialog={handleSetGlobalDialog}
            >
              <TopicSelector />
            </Layout1>
          }
        />
        <Route
          path="/practice"
          element={
            <Layout1
              user={user}
              firstName={activeUserName}
              handleLogout={handleLogout}
              globalNotice={globalNotice}
              setGlobalNotice={handleSetGlobalNotice}
              dialog={globalDialog}
              setGlobalDialog={handleSetGlobalDialog}
            >
              <SelectionGrid />
            </Layout1>
          }
        />
        <Route
          path="/test"
          element={
            <RecorderPage />
          }
        />


        <Route
          path="/history"
          element={
            <Layout1
              user={user}
              firstName={activeUserName}
              handleLogout={handleLogout}
              globalNotice={globalNotice}
              setGlobalNotice={handleSetGlobalNotice}
              dialog={globalDialog}
              setGlobalDialog={handleSetGlobalDialog}
            >
              <TestHistoryPage />
            </Layout1>
          }
        />
        <Route
          path="/result"
          element={
            <Layout1
              user={user}
              firstName={activeUserName}
              handleLogout={handleLogout}
              globalNotice={globalNotice}
              setGlobalNotice={handleSetGlobalNotice}
              dialog={globalDialog}
              setGlobalDialog={handleSetGlobalDialog}
            >
              <TestAttemptHistoryPage />
            </Layout1>
          }
        />
        <Route
          path="/login"
          element={
            <Layout1
              user={user}
              firstName={activeUserName}
              handleLogout={handleLogout}
              globalNotice={globalNotice}
              setGlobalNotice={handleSetGlobalNotice}
              dialog={globalDialog}
              setGlobalDialog={handleSetGlobalDialog}
            >
              <Login setGlobalNotice={handleSetGlobalNotice} />
            </Layout1>
          }
        />
        <Route
          path="/signup"
          element={
            <Layout1
              user={user}
              firstName={activeUserName}
              handleLogout={handleLogout}
              globalNotice={globalNotice}
              setGlobalNotice={handleSetGlobalNotice}
              dialog={globalDialog}
              setGlobalDialog={handleSetGlobalDialog}
            >
              <SignUp setGlobalNotice={handleSetGlobalNotice} />
            </Layout1>
          }
        />
        <Route
          path="/about"
          element={
            <Layout1
              user={user}
              firstName={activeUserName}
              handleLogout={handleLogout}
              globalNotice={globalNotice}
              setGlobalNotice={handleSetGlobalNotice}
              dialog={globalDialog}
              setGlobalDialog={handleSetGlobalDialog}
            >
              <AboutScreen />
            </Layout1>
          }
        />

        <Route
          path="/pricing"
          element={
            <Layout1
              user={user}
              firstName={activeUserName}
              handleLogout={handleLogout}
              globalNotice={globalNotice}
              setGlobalNotice={handleSetGlobalNotice}
              dialog={globalDialog}
              setGlobalDialog={handleSetGlobalDialog}
            >
              <PriceScreen />
            </Layout1>
          }
        />
        <Route
          path="/privacy"
          element={
            <Layout1
              user={user}
              firstName={activeUserName}
              handleLogout={handleLogout}
              globalNotice={globalNotice}
              setGlobalNotice={handleSetGlobalNotice}
              dialog={globalDialog}
              setGlobalDialog={handleSetGlobalDialog}
            >
              <PrivacyPolicyPage />
            </Layout1>
          }
        />
        <Route
          path="/terms"
          element={
            <Layout1
              user={user}
              firstName={activeUserName}
              handleLogout={handleLogout}
              globalNotice={globalNotice}
              setGlobalNotice={handleSetGlobalNotice}
              dialog={globalDialog}
              setGlobalDialog={handleSetGlobalDialog}
            >
              <TermsOfServicePage />
            </Layout1>
          }
        />
        <Route path="/auth/callback" element={<AuthCallback setGlobalNotice={handleSetGlobalNotice} />} />

      </Routes>
    </Router>
  );
}

